import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Home";
import InterventionDetail from "@/pages/InterventionDetail";
import InterventionWizard from "@/pages/InterventionWizard";
import { EquipmentList, EquipmentDetail } from "@/pages/Equipment";
import { ContractList, ContractDetail } from "@/pages/Contracts";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Interventions from "@/pages/Interventions";
import Orders from "@/pages/Orders";
import Calendar from "@/pages/Calendar";
import Reminders from "@/pages/Reminders";
import Workshop from "@/pages/Workshop";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Billing from "@/pages/Billing";
import Backups from "@/pages/Backups";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-slate-400" data-testid="auth-loading">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="calendrier" element={<Calendar />} />
              <Route path="interventions" element={<Interventions />} />
              <Route path="interventions/nouvelle" element={<InterventionWizard />} />
              <Route path="interventions/:id" element={<InterventionDetail />} />
              <Route path="equipements" element={<EquipmentList />} />
              <Route path="equipements/:id" element={<EquipmentDetail />} />
              <Route path="contrats" element={<ContractList />} />
              <Route path="contrats/:id" element={<ContractDetail />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="commandes" element={<Orders />} />
              <Route path="rappels" element={<Reminders />} />
              <Route path="atelier" element={<Workshop />} />
              <Route path="equipe" element={<Team />} />
              <Route path="parametres" element={<Settings />} />
              <Route path="facturation" element={<AdminOnly><Billing /></AdminOnly>} />
              <Route path="sauvegardes" element={<AdminOnly><Backups /></AdminOnly>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
